import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Header,
  TextField,
  Button,
  XLText,
  XMText,
  DefaultText,
  FlexWrapper,
  StyledLink,
  XCMText,
  Modal,
  Toast,
  Error,
  PageWrapper
} from '../components'
import { Formik, Form, Field } from 'formik'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'
import { signUpValidator, loginValidator, resetEmailValidator } from '../utlis/validators'
import { get, isEmpty, has } from 'lodash'
import GoogleLogin from 'react-google-login'
import qs from 'qs'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

const FormikForm = styled(Form)`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

class LoginAndSignup extends Component {
  state = { isLoading: false, isLoadingFb: false, isLoadingGoogle: false, error: '', openToast: false, message: '' }
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openToast: false })
  }

  componentDidMount() {
    if (this.props.location.hash) {
      const dat = qs.parse(window.location.hash.slice(1, window.location.hash.length))
      if (dat.id_token) {
        this.responseGoogle({ Zi: { id_token: dat.id_token } })
      }
    }
  }

  fetchUserDetails = async () => {
    //fetching user details
    const query = {
      filter: {
        include: ['dislikes', 'allergies', 'grocers', 'diets']
      }
    }

    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}?access_token=${Cookies.get('access_token')}&${qs.stringify(query)}`
      )
      await Cookies.set('userDetails', data, { path: '/', expires: 365 })
      if (Cookies.get('previousPath') !== undefined) {
        this.props.history.push(`${Cookies.get('previousPath')}`)
      } else {
        this.props.history.push('/home')
      }
    } catch (error) {
      console.log('ERROR', get(error.response, 'data.error.message', ''))
    }
  }

  responseFacebook = async response => {
    this.setState({ isLoadingFb: true })
    try {
      const { data } = await axios.post(`${API_URL}/users/createUser`, {
        userData: { source: 'facebook', socialAccessToken: response.accessToken }
      })
      await Cookies.set('access_token', data.status.token, { path: '/', expires: 365 })
      await Cookies.set('user_id', data.status.user.id, { path: '/', expires: 365 })
      await this.fetchUserDetails()
      this.props.history.push('/home')
    } catch (error) {
      this.setState({ isLoadingFb: false })
      console.log('ERORR', error)
    }
  }
  responseGoogle = async response => {
    this.setState({ isLoadingGoogle: true })
    try {
      const { data } = await axios.post(`${API_URL}/users/createUser`, {
        userData: { source: 'google', socialAccessToken: response.Zi.id_token }
      })
      await Cookies.set('access_token', data.status.token, { path: '/', expires: 365 })
      await Cookies.set('user_id', data.status.user.id, { path: '/', expires: 365 })
      await this.fetchUserDetails()
      this.props.history.push('/home')
    } catch (error) {
      this.setState({ isLoadingGoogle: false })
      console.log('ERORR', error)
    }
  }

  render() {
    const {
      location: { pathname, search }
    } = this.props
    const urlArr = window.location.href.split('/')
    const fpUrl = urlArr[0] + '//' + urlArr[2]
    const { isLoading, isLoadingFb, isLoadingGoogle, error, openToast, message, comingSoonModel } = this.state
    return (
      <React.Fragment>
        <Header icon="arrowBack" onClickBack={() => this.props.history.goBack()} backgroundColor="transparent" />
        <PageWrapper viewPadding="22.4% 4.3% 4%" modifyPadding="84px 30px 16px">
          {pathname === '/auth/login' ? (
            <FlexWrapper viewPadding={'3% 0% 0'} height="100%">
              <FlexWrapper width="100%" alignItems="center">
                <XLText>Hi there!</XLText>
                <FlexWrapper viewPadding="8px 0 0" flexBasis="auto" alignItems="center">
                  <DefaultText textAlign="center">Login to continue using GreenChoice</DefaultText>
                </FlexWrapper>
                <Formik
                  enableReinitialize
                  initialValues={{
                    email: '',
                    password: ''
                  }}
                  validate={loginValidator}
                  validateOnChange
                  onSubmit={async values => {
                    if (has(this.props.location, 'previousPath')) {
                      Cookies.set('previousPath', this.props.location.previousPath, { path: '/' })
                    }
                    this.setState({ isLoading: true, error: '' })
                    try {
                      const { data } = await axios.post(`${API_URL}/users/login`, {
                        email: values.email,
                        password: values.password
                      })
                      await this.setState({ isLoading: false })
                      if (Cookies.get('previousPath') !== undefined) {
                        this.props.history.push(`${Cookies.get('previousPath')}`)
                      }
                      await Cookies.set('user_id', data.userId, { path: '/', expires: 365 })
                      await Cookies.set('access_token', data.id, { path: '/', expires: 365 })
                    } catch (error) {
                      this.setState({ isLoading: false, error: get(error.response, 'data.error.message', '') })
                    }
                    this.fetchUserDetails()
                  }}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="email"
                        render={({ field }) => (
                          <TextField {...field} type="email" label="Email" required error={formikBag.errors.email} />
                        )}
                      />
                      <Field
                        name="password"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="password"
                            label="Password"
                            required
                            error={formikBag.errors.password}
                          />
                        )}
                      />
                      <Button
                        volume="filled"
                        type="submit"
                        label="Log in"
                        namespace="Email Login"
                        isLoading={isLoading}
                        disabled={isLoading}
                      />
                      <Error response>{error}</Error>
                      <StyledLink to="/auth/forgot-password">Forgot Password ?</StyledLink>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
              <FlexWrapper viewMargin="auto 0" alignItems="center">
                <XMText>
                  No account?{' '}
                  <StyledLink to="/auth/social-login" onClick={() => this.setState({ error: '' })}>
                    Create one
                  </StyledLink>
                </XMText>
              </FlexWrapper>
            </FlexWrapper>
          ) : pathname === '/auth/social-login' ? (
            <FlexWrapper height="100%" justifyContent="space-between">
              <div>
                <XLText>Welcome to GreenChoice!</XLText>
                <FlexWrapper viewPadding="8px 0 0" flexBasis="auto" alignItems="center">
                  <DefaultText textAlign="center">
                    Sign up to find and shop groceries that align with your values, dietary needs and budget.
                  </DefaultText>
                </FlexWrapper>
              </div>
              <FlexWrapper flexBasis="auto" alignItems="center" viewPadding="0 0 0">
                {/* <FacebookLogin
                  appId="344453073041351"
                  scope="public_profile, email"
                  redirectUri={window.location.href}
                  callback={this.responseFacebook}
                  render={renderProps => (
                    <Button
                      disabled={isLoadingFb}
                      isLoading={isLoadingFb}
                      volume="filled"
                      bgColor="#39579a"
                      icon="facebook"
                      namespace="Login/Signup"
                      label="Login with Facebook"
                      margin="0 0 20px 0"
                      social
                      onClick={() => this.setState({ comingSoonModel: true })}
                      // onClick={renderProps.onClick}
                    />
                  )}
                />
                <GoogleLogin
                  clientId="933326877796-e06t7d53ltnjggn680bu4608fe690e69.apps.googleusercontent.com"
                  render={renderProps => (
                    <Button
                      disabled={isLoadingGoogle}
                      isLoading={isLoadingGoogle}
                      volume="filled"
                      bgColor="#2c56dd"
                      icon="google"
                      namespace="Login/Signup"
                      label="Login with Google"
                      margin="0 0 20px 0"
                      onClick={() => this.setState({ comingSoonModel: true })}
                      // onClick={renderProps.onClick}
                      social
                    />
                  )}
                  buttonText="Login"
                  uxMode="redirect"
                  onSuccess={this.responseGoogle}
                  onFailure={this.responseGoogle}
                /> */}

                {/* <Button
                  volume="filled"
                  bgColor="#068489"
                  icon="email"
                  namespace="Login/Signup"
                  label="Signup with Email"
                  margin="0 0 20px 0"
                  social
                  onClick={() => this.props.history.push('/auth/signup')}
                /> */}
              </FlexWrapper>

              <FlexWrapper alignItems="center" viewMargin="0 0">
                <XMText>
                  Already a member?{' '}
                  <StyledLink to="/auth/login" onClick={() => this.setState({ error: '' })}>
                    Login
                  </StyledLink>
                </XMText>
              </FlexWrapper>
            </FlexWrapper>
          ) : pathname === '/auth/forgot-password' ? (
            <FlexWrapper justifyContent="space-between" alignItems="center" height="100%">
              <FlexWrapper width="100%" alignItems="center">
                <XLText>Forgot Password!</XLText>
                <FlexWrapper viewPadding="8px 0 0" flexBasis="auto" alignItems="center" />
                <Formik
                  enableReinitialize
                  initialValues={{
                    email: ''
                  }}
                  validate={resetEmailValidator}
                  validateOnChange
                  onSubmit={async (values, { resetForm }) => {
                    this.setState({ isLoading: true, error: '' })
                    try {
                      const { data } = await axios.post(`${API_URL}/users/forgot-password`, {
                        email: values.email,
                        url: fpUrl
                      })
                      await this.setState({ isLoading: false, openToast: true, message: get(data, 'message', '') })
                      if (get(data, 'status', '') === 200) {
                        resetForm()
                      }
                    } catch (error) {
                      this.setState({ isLoading: false, error: get(error.response, 'data.error.message', '') })
                    }
                  }}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="email"
                        render={({ field }) => (
                          <TextField {...field} type="email" label="Email" error={formikBag.errors.email} />
                        )}
                      />
                      <Button
                        margin="10px 0 0 0"
                        volume="filled"
                        type="submit"
                        label="Submit"
                        namespace="Forgot Password"
                        isLoading={isLoading}
                        disabled={isLoading}
                      />
                      <Error response>{error}</Error>
                      <StyledLink to="/auth/login" onClick={() => this.setState({ error: '' })}>
                        Go to Login
                      </StyledLink>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
              <FlexWrapper viewMargin="auto 0" alignItems="center">
                <XMText>
                  No account?{' '}
                  <StyledLink to="/auth/social-login" onClick={() => this.setState({ error: '' })}>
                    Create one
                  </StyledLink>
                </XMText>
              </FlexWrapper>
            </FlexWrapper>
          ) : (
            <FlexWrapper justifyContent="space-between" alignItems="center">
              <FlexWrapper width="100%" alignItems="center">
                <XLText>Hi there!</XLText>
                <FlexWrapper viewPadding="8px 0 0" flexBasis="auto" alignItems="center">
                  <DefaultText textAlign="center">Sign up to continue using GreenChoice</DefaultText>
                </FlexWrapper>
                <Formik
                  enableReinitialize
                  initialValues={{
                    name: '',
                    email: '',
                    password: '',
                    refCode: !isEmpty(search) ? search.split('=')[1] : ''
                  }}
                  onSubmit={async values => {
                    if (has(this.props.location, 'previousPath')) {
                      Cookies.set('previousPath', this.props.location.previousPath, { path: '/' })
                    }
                    this.setState({ isLoading: true, error: '' })
                    try {
                      const { data } = await axios.post(`${API_URL}/users`, {
                        name: values.name,
                        email: values.email,
                        password: values.password,
                        refCode: values.refCode
                      })
                      this.setState({ isLoading: false })
                      this.props.history.push('/auth/login')
                    } catch (error) {
                      this.setState({
                        isLoading: false,
                        error: get(error.response, 'data.error.details.messages.email[0]', '')
                      })
                      console.log('ERROR', get(error.response, 'data.error.details.messages.email[0]', ''))
                    }
                  }}
                  validate={signUpValidator}
                  validateOnChange
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="name"
                        render={({ field }) => (
                          <TextField {...field} label="Full Name" required error={formikBag.errors.name} />
                        )}
                      />
                      <Field
                        name="email"
                        render={({ field }) => (
                          <TextField {...field} label="Email" type="email" required error={formikBag.errors.email} />
                        )}
                      />
                      <Field
                        name="password"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Password"
                            type="password"
                            required
                            error={formikBag.errors.password}
                          />
                        )}
                      />
                      <Field name="refCode" render={({ field }) => <TextField {...field} label="Referral Code" />} />
                      <Button
                        volume="filled"
                        type="submit"
                        label="Sign up"
                        namespace="Login/Signup"
                        margin="14px 0 0"
                        disabled={isLoading}
                        isLoading={isLoading}
                      />
                      <Error response>{error}</Error>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
              <FlexWrapper viewMargin="auto 0" alignItems="center">
                <XMText>
                  Already a member?{' '}
                  <StyledLink to="/auth/login" onClick={() => this.setState({ error: '' })}>
                    Login
                  </StyledLink>
                </XMText>
              </FlexWrapper>
            </FlexWrapper>
          )}
          <Toast open={openToast} slideFromTop message={message} onClose={this.handleClose} />
        </PageWrapper>
        <Modal
          title=""
          show={comingSoonModel}
          hide={!comingSoonModel}
          // list={openList || listExist}
          onClose={() => this.setState({ comingSoonModel: false })}>
          <FlexWrapper alignItems="center">
            <XCMText>Coming Soon!</XCMText>
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}

export default LoginAndSignup



// WEBPACK FOOTER //
// ./src/pages/LoginAndSignup.js